import type { Observable } from "rxjs";
import type { FormDialogConfig } from "../models";

export function DialogConfig(header: string, data: { formDialogConfigs?: Observable<Array<FormDialogConfig>>, [key: string]: any }, width: string = null): object {
  return {
    width: width ?? '400px',
    height: 'auto',
    contentStyle: { overflow: 'auto' },
    baseZIndex: 10000,
    header,
    data,
  };
}
